
<div
  :id="vnodeId"
  data-identity="CountdownTimer"
  :data-vnode-id="vnodeId"
  class="cvt-editor-countdown-timer"
  :class="classes"
  draggable="true"
  @dragstart="dragstart"
  @dragend="dragend"
  @contextmenu.prevent.stop="showContextMenu"
  @click="select"
  @mouseover="target"
>
  <div :class="cdtWrapClasses">
    <template v-if="type === 'dateAndTimeBased'">
      <div class="cdtHmsOuterWrap day">
        <div class="cdtHmsInnerWrap">
          <span class="cdtTime">00</span>
        </div>
        <div class="cdtHmsLabel">DAYS</div>
      </div>
      <div  class="cdtHmsOuterWrap hour">
        <div class="cdtHmsInnerWrap">
          <span class="cdtTime">00</span>
        </div>
        <div class="cdtHmsLabel">HOURS</div>
      </div>
      <div class="cdtHmsOuterWrap minute">
        <div class="cdtHmsInnerWrap">
          <span class="cdtTime">00</span>
        </div>
        <div class="cdtHmsLabel">MINUTES</div>
      </div>
      <div class="cdtHmsOuterWrap second d-none">
        <div class="cdtHmsInnerWrap">
          <span class="cdtTime">00</span>
        </div>
        <div class="cdtHmsLabel">SECONDS</div>
      </div>
    </template>
    <template v-else-if="type === 'urgencyBased'">
      <div class="cdtHmsOuterWrap day">
        <span class="cdtTime">00</span>
        <span class="cdtTimeLabel">DAYS</span>
      </div>
      <div class="cdtHmsSepratorWrap">
        <span class="cdtTime">:</span>
      </div>
      <div class="cdtHmsOuterWrap hour">
        <span class="cdtTime">00</span>
        <span class="cdtTimeLabel">HOURS</span>
      </div>
      <div class="cdtHmsSepratorWrap ">
        <span class="cdtTime">:</span>
      </div>
      <div class="cdtHmsOuterWrap minute">
        <span class="cdtTime">00</span>
        <span class="cdtTimeLabel">MINUTES</span>
      </div>
      <div class="cdtHmsSepratorWrap d-none">
        <span class="cdtTime">:</span>
      </div>
      <div class="cdtHmsOuterWrap second d-none">
        <span class="cdtTime">00</span>
        <span class="cdtTimeLabel">SECONDS</span>
      </div>
    </template>
  </div>

</div>
